<template>
  <BoardView :title="$t('title')">
    <FormReviewImport
      :reviewImport="reviewImport" />
  </BoardView>
</template>

<script>
import BoardView from '@components/board/BoardView'
import FormReviewImport from './components/FormReviewImport'

export default {
  components: {
    BoardView,
    FormReviewImport,
  },
  data() {
    return {
      reviewImport: this.$store.getters.reviewImportFactory(),
    }
  },
}
</script>

<i18n>
{
  "en": {
    "title": "Import reviews",
    "submit": "Save"
  }
}
</i18n>
